module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/ft04-25dd43a3e02d359004c1c6dafb550140.png";